import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { cn } from 'cn';

import { DOMAINS, getStaticUrl } from '@/shared-utilities';

import { ProjectPoweredBy } from '..';

interface Props {
  description?: string;
  icon?: FontAwesomeIconProps['icon'];
  iconClassName?: string;
  title: string;
  isWidget?: boolean;
  className?: string;
  showHomePageButton?: boolean;
  showPoweredBy?: boolean;
  homeButtonLabel?: string;
  imageAlt?: string;
}

function ProjectMessage({
  showHomePageButton,
  showPoweredBy,
  className,
  isWidget,
  title,
  description,
  iconClassName,
  icon,
  homeButtonLabel,
  imageAlt = '',
}: Props) {
  return (
    <div
      className={cn(
        'flex min-h-dvh w-screen flex-col items-center justify-center bg-[linear-gradient(225deg,rgb(232,237,255)_0%,rgb(255,232,236)_10%,rgb(255,255,255)_50%,rgb(232,237,255)_100%)]',
        className
      )}
      data-test='project-message'
    >
      <div
        className='flex flex-3 flex-col items-center justify-center gap-12 data-[state=widget]:gap-8'
        data-state={isWidget ? 'widget' : ''}
        data-test='project-message-icon'
      >
        {icon ? (
          <FontAwesomeIcon icon={icon} className={iconClassName} />
        ) : (
          <img
            src={getStaticUrl('images/survey-expired.svg')}
            alt={imageAlt}
            data-state={isWidget ? 'widget' : ''}
            className='w-52 sm:w-auto'
          />
        )}
        <div
          className='flex flex-col items-center justify-center gap-4 px-4 data-[state=widget]:px-0'
          data-state={isWidget ? 'widget' : ''}
        >
          <h1
            className='smtext-4xl w-fit text-center font-display text-2xl font-semibold text-gray-900 data-[state=widget]:text-xl'
            data-state={isWidget ? 'widget' : ''}
            data-test='project-message-title'
          >
            {title}
          </h1>
          <p
            data-state={isWidget ? 'widget' : ''}
            className='mx-auto max-w-2xl self-stretch text-center font-display text-wrap text-gray-500 data-[state=widget]:max-w-96 data-[state=widget]:text-sm'
            data-test='project-message-description'
          >
            {description}
          </p>
        </div>
        {showHomePageButton && (
          <a
            href={`https://${DOMAINS.AI_PROD}`}
            className='inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-gray-400 px-4 py-2 text-zinc-800 transition-colors visited:text-zinc-900 hover:bg-gray-900 hover:text-white'
            data-test='project-message-home-button'
          >
            <div className='font-display text-sm/tight font-semibold'>
              {homeButtonLabel}
            </div>
          </a>
        )}
      </div>

      {showPoweredBy && (
        <div className='relative top-12 flex-2'>
          <ProjectPoweredBy />
        </div>
      )}
    </div>
  );
}

export default ProjectMessage;
